import type { DocumentMeta, Rect } from '../core/types';
import { Texture } from '../gl/texture';
import type { Engine } from './engine';
import type { EngineHistoryOp } from './historyOps';
import { applyToLayer } from './ops';

export type LiquifyTool =
  | 'push'
  | 'twirl'
  | 'twirlCCW'
  | 'pucker'
  | 'bloat'
  | 'freeze'
  | 'thaw'
  | 'reconstruct';

export const LIQUIFY_MODE: Record<
  Exclude<LiquifyTool, 'freeze' | 'thaw'>,
  number
> = {
  push: 0,
  twirl: 1,
  twirlCCW: 1,
  pucker: 2,
  bloat: 3,
  reconstruct: 4,
};

/**
 * Bakes a displacement field into the layer. `displace` is RGBA16F with the
 * offset in RG, in source texels.
 */
export function commitLiquify(
  engine: Engine,
  doc: DocumentMeta,
  layerId: string,
  displace: Texture,
): EngineHistoryOp[] | null {
  return applyToLayer(engine, doc, layerId, {
    x: 0,
    y: 0,
    width: doc.width,
    height: doc.height,
  } satisfies Rect, (target, layerTexture) => {
    engine.renderer.applyLiquify(target.framebuffer, layerTexture, displace);
  });
}
